import script from "./ArchiveMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveMain.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveMain.vue?vue&type=style&index=0&id=fa093b8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa093b8c"]])

export default __exports__